import { type MetricField } from "../../gql-generated/types";
import { TOTAL_VALUE_DEFAULT_FORMATTER, totalValueFormattersMap } from "../formatters/formattersMap";
import { type InsightsMetrics, type StatsItem } from "../models";

export const mapTotalValueFormatted =
    (fieldName: MetricField) =>
    (metric: InsightsMetrics<StatsItem> | undefined): InsightsMetrics<StatsItem> | undefined => {
        if (!metric) {
            return undefined;
        }
        const formatter = totalValueFormattersMap[fieldName] ?? TOTAL_VALUE_DEFAULT_FORMATTER;
        return {
            ...metric,
            totalValueFormatted: formatter(metric.totalValue),
        };
    };
